import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { getUri } from '../../sso';

export const effect = createListenerEffect(
  'openSsoWindow<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    const uri = action.payload;

    const leftPosition = window.screen.availWidth / 2 - 100;
    const windowParams = `width=400,height=600,left=${leftPosition},top=60,titlebar=no,menubar=no,status=no,location=no`;

    window.SSOWindow = window.open(uri, 'SSOWindow', windowParams);
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: getUri.fulfilled,
  effect,
});

export default middleware;
